import { onlyDigit } from '@/functions/function.js';
import $ from 'jquery'

export default {
    name: 'ajout-article',
    components: {},
    props: [],
    data () {
        return {
            loading: false,
            loading_attribut: false,
            libelle: '',
            minimum: 0,
            optimale: 0,
            prix: 0,
            lot_article: '',
            attributs: [],
            type: [],
            type_is_selected: false,
            info_loading: false
        }
    },
    computed: {
        type_articles() {
            return this.$store.getters['types']
        },

        lot_article_ref_id() {
            return this.$store.getters['lot_article_ref_id']
        },

        article() {
            return this.$store.getters['article']
        },
    },

    mounted () {
        setTimeout(() => {
            $('.p-content').fadeIn();
        }, 500);

        this.$store.dispatch("getTypes");
        this.type= [];
        this.changeType(1);

        if (this.lot_article_ref_id) {
            this.selectArticle()
        }
    },
    methods: {
        selectArticle() {
            this.info_loading = true;
            const data = {
                month: "",
                one_date: this.setDates().today_date,
                from_date: "",
                to_date: "",
                article_id: this.lot_article_ref_id
            }
            this.$store.dispatch("getArticle", data).then(() => {
                this.libelle = this.article.libelle;
                this.minimum = this.article.minimum;
                this.optimale = this.article.optimale;
                this.prix = ""

                this.attributs = [];
                setTimeout(() => {
                    this.getAttributs()
                }, 600);
                

                this.info_loading = false;
            })
        },

        getAttributs() {
			for (let i = 0; i < this.type['attribut_articles'].length; i++) {
                let valeur = ''
                if (this.type['attribut_articles'][i].libelle == 'Unité Dosage') {
					valeur = this.article.attribut[this.type['attribut_articles'][i].libelle]
					if (valeur != null) {
						valeur = valeur.toLowerCase()
					}
				} else if (this.type['attribut_articles'][i].libelle == 'Forme') {
					valeur = this.getForme(this.article.attribut[this.type['attribut_articles'][i].libelle])
				} else if (this.type['attribut_articles'][i].libelle == 'Prix cession') {
					valeur = ""
				} else {
					valeur = this.article.attribut[this.type['attribut_articles'][i].libelle]
				} 

                this.attributs.push({
                    valeur: valeur,
                    libelle: this.type['attribut_articles'][i].libelle,
					attribut: this.type['attribut_articles'][i].id
                });
			}
		},

        getForme(abreviation) {
			let forme = ''
			if (abreviation != null) {
				abreviation = abreviation.trim()
			}
			
			switch (abreviation) {
				case 'Aéro-Do':
					forme = 'Aérosol-Doseur'
					break
				case 'Amp Buv':
					forme = 'Ampoule buvable'
					break
				case 'CP':
					forme = 'Comprimés'
					break
				case 'CP EFF':
					forme = 'Comprimés Effervescent'
					break 
				case 'CP Eff':
					forme = 'Comprimés Effervescent'
					break 
				case 'INJ':
					forme = 'Injectable'
					break 
				case 'Inj':
					forme = 'Injectable'
					break 
				case 'Ovu':
					forme = 'Ovule'
					break
				case 'Oph':
					forme = 'Ophtalmique'
					break 
				case 'Sch Péd':
					forme = 'Sachet Pédiatrique'
					break 
				case 'Solu':
					forme = 'Solution'
					break 
				case 'Sp':
					forme = 'Sirop'
					break 
				case 'Susp':
					forme = 'Suspension'
					break 
				case 'Suppo':
					forme = 'Suppositoire'
					break 
				case 'Voie rectale':
					forme = 'Voie Rectale'
					break
				default:
					forme = abreviation
					break
			}

			return forme
		},

        async changeType(id) {
            this.loading_attribut=true

            try {
                await this.$store.dispatch("getType",id)

                this.type= this.$store.getters['type']

                this.attributs= []

                let j = 0;
                for ( let i= 0; i<this.type['attribut_articles'].length ; i++) {
                    this.attributs.push({ valeur: [],  attribut: this.type['attribut_articles'][i].id });
                    j++;
                }
                if (j > 0) {
                    this.type_is_selected = true;
                }

                this.loading_attribut=false 
    
            } catch {
                this.loading_attribut=false 
            }
        },

        async submitForm() {
            const isValid = await this.$refs.observer.validate();

            if (isValid) {
                this.attributs.forEach((attr, index) => {
                    if (typeof attr.valeur === 'object' && attr.valeur !== null) {
                        // Use optional chaining in case libelle doesn't exist
                        this.attributs[index].valeur = attr.valeur.libelle || '';
                    }
                });

                const data = {
                    libelle:  this.libelle,
                    lot_article: this.lot_article,
                    prix: (this.prix != '')?this.prix:0,
                    minimum: (this.minimum != '')?this.minimum:0,
                    optimale: (this.optimale != '')?this.optimale:0,
                    type_article: 1,
                    attributs: this.attributs
                }
                
                this.loading=true;
                this.$store.dispatch("saveArticle",data).then(
                    response => {
                        if (response) {
                            this.loading=true;
                            //this.$router.push({ path: `/medicaments/show/${response.id}` }) 
                            this.$router.push({ path: `/medicaments` }) 
                        } else {
                            this.loading=false;
                        }
                    }
                ).catch(() => {
                    this.loading = false;
                }) 
            }
            
        },

        /**
         * Authorise uniquement les chiffres
         * @param {*} input_id 
        */
        async allowOnlyDigit(input_id)
        {
            onlyDigit.onlyDigit(input_id)
        }
    }
}
  
  
  